export default {
  cancellationAccount: {
    title: "注销",
    componentPath: "Cancellation"
  },
  cancellationFill: {
    title: "填写注销账号",
    componentPath: "Fill"
  },
  cancellationInfo: {
    title: "填写注销信息",
    componentPath: "Info"
  },
  cancellationStatus: {
    title: "极致游戏账号注销",
    componentPath: "Status"
  }
};
